<template>
  <div>
    <div class="flex justify-between pb-6">
      <span class="text-base font-semibold truncate mr-1">Assistance Resolution</span>
      <span class="text-base"> ({{ totalFilteredRequests }})</span>
    </div>

    <resolution-filter-item v-for="resolution in data"
                            :key="resolution.legendType"
                            :resolution="resolution"
                            :category-index="resolutionFilterData.categoryIndex"
                            :total-requests="totalRequests"
                            :class="resolveFilterItemClasses(resolution)"
                            @select-resolution="selectResolution(resolution.legendType)"
    />
  </div>
</template>

<script>
import ResolutionFilterItem from '@/components/analytics/filter/ResolutionFilterItem'
import remove from 'ramda/src/remove'
import append from 'ramda/src/append'

export default {
  name: 'ResolutionFilter',

  components: {
    ResolutionFilterItem
  },

  props: {
    data: {
      type: Array,
      default: () => []
    },
    resolutionFilterData: {
      type: Object,
      default: () => {}
    },
    selectedResolutions: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    totalFilteredRequests() {
      const filteredResolutions = this.data.filter(({ legendType }) => {
        return this.selectedResolutions.includes(legendType)
      })
      return filteredResolutions.reduce((sum, { data }) => {
        return sum + data[this.resolutionFilterData.categoryIndex][1]
      }, 0)
    },

    totalRequests() {
      return this.data.reduce((sum, { data }) => {
        return sum + data[this.resolutionFilterData.categoryIndex][1]
      }, 0)
    }
  },

  methods: {
    resolveFilterItemClasses(resolution) {
      const classes = []
      const isResolutionSelected = this.selectedResolutions.includes(resolution.legendType)
      if (isResolutionSelected) {
        classes.push(`bg-${resolution.colorType} bg-opacity-20`)
      }

      if (this.isLoading) {
        classes.push('cursor-loading')
      } else {
        classes.push(this.selectedResolutions.length === 1 && isResolutionSelected ? 'cursor-not-allowed' : 'cursor-pointer')
      }

      return classes
    },

    selectResolution(resolution) {
      if (this.isLoading) return

      const resolutionIndex = this.selectedResolutions.indexOf(resolution)
      if (resolutionIndex !== -1) {
        if (this.selectedResolutions.length === 1) return

        this.$emit('change', remove(resolutionIndex, 1, this.selectedResolutions))
        return
      }
      this.$emit('change', append(resolution, this.selectedResolutions))
    }
  }

}
</script>
